import type {
  AdminColegioAsignacion,
  AdminColegioAsignacionCreate,
  AdminColegioAsignacionUpdate,
  AdminColegioCurso,
  AdminColegioCursoUpdate,
  AdminColegioProfesor,
  AdminColegioProfesorUpdate,
  ReporteColegio,
  ReporteAsistenciaCurso,
  ReporteProgresoAlumno,
} from "../../app/admin-colegio/administrar/dto/admin.dto";
import { apiClientWeb } from "../../lib/apiClientWeb";

export const adminColegioAdministracionService = {
  getCursos: async (): Promise<AdminColegioCurso[]> => {
    const response = await apiClientWeb.get("/api/admin-colegio/cursos");
    return response.data.data;
  },

  updateCurso: async (
    idCurso: number,
    data: AdminColegioCursoUpdate
  ): Promise<AdminColegioCurso> => {
    const response = await apiClientWeb.patch(
      `/api/admin-colegio/cursos/${idCurso}`,
      data
    );
    return response.data.data;
  },

  getProfesores: async (): Promise<AdminColegioProfesor[]> => {
    const response = await apiClientWeb.get("/api/admin-colegio/profesores");
    return response.data.data;
  },

  updateProfesor: async (
    idUsuario: number,
    data: AdminColegioProfesorUpdate
  ): Promise<AdminColegioProfesor> => {
    const response = await apiClientWeb.patch(
      `/api/admin-colegio/profesores/${idUsuario}`,
      data
    );
    return response.data.data;
  },

  getAsignaciones: async (): Promise<AdminColegioAsignacion[]> => {
    const response = await apiClientWeb.get("/api/admin-colegio/asignaciones");

    return response.data.data.map((a: any) => ({
      idAsignacion: a.idProfesorCurso,
      profesorId: a.profesorId,
      cursoId: a.cursoId,
      vigente: a.estaActivo,
      fecha: a.fechaInicio,
      profesor: a.profesor ?? null,
    }));
  },

  createAsignacion: async (data: AdminColegioAsignacionCreate) => {
    const response = await apiClientWeb.post(
      "/api/admin-colegio/asignaciones",
      {
        profesorId: data.profesorId,
        cursoId: data.cursoId,
        estaActivo: true,
      }
    );

    return response.data.data;
  },

  updateAsignacion: async (
    idProfesorCurso: number,
    data: AdminColegioAsignacionUpdate
  ): Promise<AdminColegioAsignacion> => {
    const response = await apiClientWeb.patch(
      `/api/admin-colegio/asignaciones/${idProfesorCurso}`,
      data
    );

    return response.data.data;
  },

  getReporteColegio: async (params: {
    fechaCreacion?: string;
    periodoInicio?: string;
    periodoFin?: string;
    cursoIds?: number[];
    profesorIds?: number[];
  }): Promise<ReporteColegio> => {
    const response = await apiClientWeb.get(
      "/api/admin-colegio/reportes/colegio",
      { params }
    );

    return response.data.data.reporte;
  },

  getReporteAsistencia: async (params: {
    periodoInicio: string;
    periodoFin: string;
    cursoIds?: number[];
    profesorIds?: number[];
  }): Promise<ReporteAsistenciaCurso> => {
    const response = await apiClientWeb.get(
      "/api/admin-colegio/reportes/asistencia",
      { params }
    );

    return response.data.data;
  },

  getReporteProgreso: async (params: {
    periodoInicio: string;
    periodoFin: string;
    cursoIds?: number[];
    profesorIds?: number[];
  }): Promise<ReporteProgresoAlumno> => {
    const response = await apiClientWeb.get(
      "/api/admin-colegio/reportes/progreso",
      { params }
    );

    return response.data.data;
  },
};
